import {RootState} from '../store';
import {StrengthObjType, Context } from "./interfaces";
import {Colors} from "../styles/constants";
import zxcvbn from "zxcvbn";

export const buildBaseHeader = (rootState: RootState) => {
  return {
    'x-csrf-token': rootState.auth.session?.csrfToken
  }
};

export const formatName = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const parseQuery = (queryString:string, targetKey:string) => {
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split('=');
    if(pair[0] === targetKey){
      return pair[1] || null;
    }
  }
  return null;
}

export const getPasswordStrength = (password:string) => {
  const strengthObj:StrengthObjType = {
    value: 0,
    description: 'Weak',
    color: Colors.CautionDark,
  }
  strengthObj.value =  zxcvbn(password).score * 25;

  if(strengthObj.value < 75) {
    strengthObj.description = 'Weak';
    strengthObj.color = Colors.Caution;
  } else if(strengthObj.value < 100) {
    strengthObj.description = 'Strong';
    strengthObj.color = Colors.Success;
  } else {
    strengthObj.description = 'Very Strong';
    strengthObj.color = Colors.Success;
  }

  return strengthObj
};

// sets the redirect url based on the context object
export const setRedirectPath = (context: Context, external: boolean = false) => {
  if (!context.url) {
    // if no url exists on the context object, return to bitpay home
    return getBaseUrl();
  } else if( !context.queryParams || !Object.keys(context.queryParams).length ){
    // if no queryParams exist on the context object only pass the url, or the url extension
    return external ? context.url : getBaseUrl() + '/' + context.url;
  } else {
    // if queryParams exist on the context object build the queryParam extension and add it to the url
    let redirectPath = context.url + '?';
    Object.keys(context.queryParams).forEach((p, index) => {
      redirectPath += p + '=' + context.queryParams![p];
      redirectPath += index === Object.keys(context.queryParams as {[p:string]: string}).length - 1 ? '' : '&';
    })
    return external ? redirectPath : getBaseUrl() + '/' + redirectPath;
  }
};

export const getBaseUrl = () => {
  const url = window.location;
  return url.protocol + "//" + url.host;
}

/**
 * Simple debounce impl
 * @param {*} fn function to debounce
 * @param {*} limit how long to wait for new execution attempt
 */
export const debounce = (fn: Function, limit = 250) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), limit);
  };
};

// Method to look for a specific cookie
const readJsCookie = (name: string) => {
  const cookies = document.cookie.split(/;\s*/);

  name += '=';

  for (let i = cookies.length - 1; i >= 0; i--) {
    if (cookies[i].indexOf(name) === 0) {
      return cookies[i].replace(name, '');
    }
  }

  return;
}

// method to look for affiliateOid cookie
export const getAffiliateOid = () => {
  return readJsCookie('bp-referral-code');
};

export const encodeContextObj = (context: Context) => {
  return btoa(JSON.stringify(context));
};

export const isLocalStorageAvailable = () => {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch(e) {
    return false;
  }
}

